import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    marginLeft: 4,
    marginRight: 4
  }
});

const TextDivider = ({ classes, ...props }) => {
  return (
    <Typography {...props} className={classes.root}>
      |
    </Typography>
  );
};

export default withStyles(styles)(TextDivider);
